import { render, staticRenderFns } from "./Tanzania.vue?vue&type=template&id=abc8cdf8&"
import script from "./Tanzania.vue?vue&type=script&lang=js&"
export * from "./Tanzania.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports